import {
  HANDLE_ERROR,
  HANDLE_LOADING,
  ANALYTICS_CUSTOMER,
  ANALYTICS_INTENT,
  ANALYTICS_UTTERANCES,
  ANALYTICS_APP_LIST,
  ANALYTICS_MESSAGE,
  CREATE_API_KEY,
  ANALYTICS_SKILL_ACTIVATION,
  ANALYTICS_SUMMARY,
  ANALYTICS_CONVERSATIONAL_PATH,
  DELETE_APP,
} from "./actionTypes";

import {
  ANALYTICS_CUSTOMER_URL,
  ANALYTICS_INTENT_URL,
  ANALYTICS_UTTERANCES_URL,
  ANALYTICS_MESSAGE_URL,
  ANALYTICS_APP_LIST_URL,
  ANALYTICS_SKILL_ACTIVATION_URL,
  CREATE_API_URL,
  ANALYTICS_SUMMARY_URL,
  ANALYTICS_CONVERSATIONAL_PATH_URL,
  ANALYTICS_APP_DELETE_URL,
} from "../../config";

import axios from "axios";

export const deleteActionApp = (payload) => async (dispatch) => {
  await dispatch({ type: HANDLE_LOADING, payload: true });
  await dispatch({ type: HANDLE_ERROR, payload: null });
  try {
    await axios({
      url: ANALYTICS_APP_DELETE_URL,
      method: "POST",
      data: {
        apiKey: payload.API_KEY_U,
      },
    });
    await dispatch({ type: DELETE_APP, payload });
    await dispatch({ type: HANDLE_LOADING, payload: false });
  } catch (err) {
    await dispatch({ type: HANDLE_LOADING, payload: false });
    await dispatch({ type: ANALYTICS_CUSTOMER, payload: null });
    await dispatch({ type: HANDLE_ERROR, payload: err });
  }
};

export const getAnalyticsCustomer = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(ANALYTICS_CUSTOMER_URL, data)
    .then((response) => {
      const data = response.data.data;
      if (typeof data === "object") {
        dispatch({ type: HANDLE_LOADING, payload: false });
        return dispatch({ type: ANALYTICS_CUSTOMER, payload: data });
      } else {
        dispatch({ type: HANDLE_LOADING, payload: false });
        dispatch({ type: ANALYTICS_CUSTOMER, payload: null });
        dispatch({ type: HANDLE_ERROR, payload: response.data });
      }
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: ANALYTICS_CUSTOMER, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};
export const getSkillActivation = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(ANALYTICS_SKILL_ACTIVATION_URL, data)
    .then((response) => {
      const data = response.data.data;
      dispatch({ type: HANDLE_LOADING, payload: false });
      return dispatch({ type: ANALYTICS_SKILL_ACTIVATION, payload: data });
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: ANALYTICS_SKILL_ACTIVATION, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};
export const getAnalyticsSummary = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(ANALYTICS_SUMMARY_URL, data)
    .then((response) => {
      const data = response.data.data;
      dispatch({ type: HANDLE_LOADING, payload: false });
      return dispatch({ type: ANALYTICS_SUMMARY, payload: data });
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: ANALYTICS_SUMMARY, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};
export const getAnalyticsIntent = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(ANALYTICS_INTENT_URL, data)
    .then((response) => {
      const data = response.data.data;
      dispatch({ type: HANDLE_LOADING, payload: false });
      return dispatch({ type: ANALYTICS_INTENT, payload: data });
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: ANALYTICS_INTENT, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};

export const getAnalyticsUtterances = (data) => async (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  try {
    let response = await axios.post(ANALYTICS_UTTERANCES_URL, data);
    await dispatch({ type: HANDLE_LOADING, payload: false });
    await dispatch({
      type: ANALYTICS_UTTERANCES,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({ type: HANDLE_LOADING, payload: false });
    dispatch({ type: ANALYTICS_UTTERANCES, payload: null });
    dispatch({ type: HANDLE_ERROR, payload: error });
  }
};

export const createAPIKey = (payload) => async (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  try {
    let { data } = await axios.post(CREATE_API_URL, {
      appName: payload.APP_NAME,
      platform: payload.PLATFORM,
      env: payload.ENVIRONMENT,
    });
    payload.API_KEY_U = data.data.Api_Key;
    payload.id = new Date().getTime();
    dispatch({ type: CREATE_API_KEY, payload });
    dispatch({ type: HANDLE_LOADING, payload: false });
  } catch (error) {
    dispatch({ type: HANDLE_LOADING, payload: false });
    dispatch({ type: HANDLE_ERROR, payload: error });
  }
};

export const getAnalyticsApplist = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(ANALYTICS_APP_LIST_URL, data)
    .then((response) => {
      const data = response.data.data;
      dispatch({ type: HANDLE_LOADING, payload: false });
      return dispatch({ type: ANALYTICS_APP_LIST, payload: data });
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: ANALYTICS_APP_LIST, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};

export const getAnalyticsConversationalPath = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(ANALYTICS_CONVERSATIONAL_PATH_URL, data)
    .then((response) => {
      const payData = response.data.data;
      dispatch({ type: HANDLE_LOADING, payload: false });
      return dispatch({
        type: ANALYTICS_CONVERSATIONAL_PATH,
        payload: payData,
      });
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: ANALYTICS_CONVERSATIONAL_PATH, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};

export const getAnalyticsMessages = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(ANALYTICS_MESSAGE_URL, data)
    .then((response) => {
      const data = response.data.data;
      dispatch({ type: HANDLE_LOADING, payload: false });
      return dispatch({ type: ANALYTICS_MESSAGE, payload: data });
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: ANALYTICS_MESSAGE, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};
